import { types } from '../../types/types';

const initialState = {
    isLoading: true,
    currentFolder: "root",
    userFolders: [],
    userFiles: [],
    adminFolders: [],
    adminFiles: []
};

export const fileFoldersReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.createFolder:
            return {
                ...state,
                userFolders: [...state.userFolders, action.payload]
            }

        case types.addFolders:
            return {
                ...state,
                userFolders: state.userFolders.concat(action.payload)
            }

        case types.removeFolder:
            const filteredFolders = state.userFolders.filter((folder) => folder.docId !== action.payload);
            return {
                ...state,
                userFolders: filteredFolders
            }


        case types.setLoadingFolders:
            return {
                ...state,
                isLoading: action.payload
            }

        case types.changeFolder:
            return {
                ...state,
                currentFolder: action.payload
            }

        case types.createFile:
            return {
                ...state,
                userFiles: [...state.userFiles, action.payload]
            }

        case types.addFiles:
            return {
                ...state,
                userFiles: state.userFiles.concat(action.payload)
            }

        case types.removeFile:
            const filteredFiles = state.userFiles.filter((file) => file.docId !== action.payload);
            return {
                ...state,
                userFiles: filteredFiles
            }

        default: return state;
    }
}
